// @flow
import React from 'react';

import appConfig from 'Config';

export const Hosting = () => {
  const hosting = appConfig.get('hosting');

  if (hosting.pixel.enabled) {
    return (
      <img
        src="https://s3.cn-north-1.amazonaws.com.cn/nscn/pixel.png"
        alt=""
        width="1"
        height="1"
      />
    );
  }

  return null;
};
